import React, { FC } from 'react'
import { IllustrationName } from '@pandiafi/design-system'
import { ResidentAppCard, ResidentAppView } from '@pandiafi/components'
import { useTranslation } from 'react-i18next'

import { Error } from 'components'

type Props = {
  title?: string
  message?: string
  illustration?: IllustrationName
  eventId?: string
  action?: React.ReactNode
}

/**
 * Full page error. The title, or the message when there is no title, is the
 * page's h1, so screen reader users hear what went wrong first.
 */
export const ErrorPage: FC<Props> = ({ title, message, ...props }) => {
  const { t } = useTranslation(['errors'])
  const heading = title ?? message ?? t('errors:other.genericError')

  return (
    <ResidentAppView title={heading} variant="full">
      <ResidentAppCard>
        <Error
          {...props}
          message={title ? message : undefined}
          className="py-6 min-tablet:py-6"
        />
      </ResidentAppCard>
    </ResidentAppView>
  )
}
